import http from './api'

export interface AdminDbTableInfo {
  table: string
  entity: string
  primaryKey: string[]
  columnCount: number
}

export interface AdminDbColumnSchema {
  name: string
  dbName: string
  type: string
  nullable: boolean
  primary: boolean
  generated: boolean
  array: boolean
}

export interface AdminDbTableSchema {
  table: string
  entity: string
  primaryKey: string[]
  columns: AdminDbColumnSchema[]
}

export interface AdminDbRowsResponse {
  rows: Record<string, unknown>[]
  total: number
  page: number
  limit: number
  totalPages: number
}

class AdminDbService {
  listTables() {
    return http.get<AdminDbTableInfo[]>('/admin/db/tables').then((r) => r.data)
  }

  getSchema(table: string) {
    return http.get<AdminDbTableSchema>(`/admin/db/tables/${encodeURIComponent(table)}/schema`).then((r) => r.data)
  }

  listRows(table: string, params?: { page?: number; limit?: number }) {
    return http
      .get<AdminDbRowsResponse>(`/admin/db/tables/${encodeURIComponent(table)}/rows`, { params })
      .then((r) => r.data)
  }

  getRow(table: string, id: string) {
    return http
      .get<Record<string, unknown>>(`/admin/db/tables/${encodeURIComponent(table)}/rows/${encodeURIComponent(id)}`)
      .then((r) => r.data)
  }

  createRow(table: string, body: Record<string, unknown>) {
    return http
      .post<Record<string, unknown>>(`/admin/db/tables/${encodeURIComponent(table)}/rows`, body)
      .then((r) => r.data)
  }

  updateRow(table: string, id: string, body: Record<string, unknown>) {
    return http
      .patch<Record<string, unknown>>(
        `/admin/db/tables/${encodeURIComponent(table)}/rows/${encodeURIComponent(id)}`,
        body,
      )
      .then((r) => r.data)
  }

  deleteRow(table: string, id: string) {
    return http
      .delete<{ ok: boolean; id: string }>(
        `/admin/db/tables/${encodeURIComponent(table)}/rows/${encodeURIComponent(id)}`,
      )
      .then((r) => r.data)
  }
}

export default new AdminDbService()
